module.exports = __webpack_public_path__ + "img/card.19a7b63f.jpg";